import React from "react"
import { Link } from 'react-router-dom';
import GetStrLocalized from '../../datas/GetStrLocalized'



interface BibleLinkProps {
    language: string;
    chapter: string;
    verses: string;
    reference: string;
}

const BibleLink: React.FC<BibleLinkProps> = ({ language, chapter, verses, reference }) => {

    return (
        <Link
            to={
                "/" + language + "/" +
                GetStrLocalized(language, "readingsFolderName") +
                "/" +
                GetStrLocalized(language, "bibleFolderName") +
                `/${chapter}` +
                (verses
                    ? `?verses=${verses}`
                    : "")
            }
        >
            {reference}
        </Link>

    )
}


export default BibleLink